<template>
  <body class="content-body">
    <LogoSection />
    <AboutUs />
    <PartnershipProgram />
    <BeAPartnerBanner :showLabel="false" :showButton="true" />
    <WhyInvest />
    <KeyAdvantages />
    <GetInTouch />
  </body>
</template>

<script>
import LogoSection from "./CompanyContent/LogoSection.vue";
import AboutUs from "./CompanyContent/AboutUs.vue";
import PartnershipProgram from "./CompanyContent/PartnersProgram.vue";
import BeAPartnerBanner from "./CompanyContent/BeAPartbanner.vue";
import WhyInvest from "./CompanyContent/WhyInvest.vue";
import KeyAdvantages from "./CompanyContent/KeyAdvantages.vue";
import GetInTouch from "./CompanyContent/GetInTouch.vue";

export default {
  name: "CompanyContent",
  components: {
    LogoSection,
    AboutUs,
    PartnershipProgram,
    BeAPartnerBanner,
    WhyInvest,
    KeyAdvantages,
    GetInTouch,
  },
};
</script>

<style scoped>
.content-body {
  padding: 29px 34px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
}
@media (max-width: 744px) {
  .content-body {
    padding: 21px 17px;
    gap: 16px;
  }
}
</style>
